import { ITennisCalendar } from "@sky-it-livedata/livedata-sports-design-system";
import { ErrorName, WidgetError } from "../../../utils/errors";
import { CalendarData } from "../types";
import { surfaceMap } from "../utils";
import { CATEGORIES } from "../../../utils/constants";
import { intcmpMap } from "../../../utils/intcmp";
import { isValidCalendar } from "./typeguards";
import { CreateCalendarWidgetInputSchema } from "cdk/graphql";

export const transformer = (obj: CalendarData): ITennisCalendar => {
  if (isValidCalendar(obj)) {
    CreateCalendarWidgetInputSchema().parse(obj.data.getCalendarWidget, {reportInput: true});
      const { circuitCalendarLink, filterList, tournaments, tournamentFilter } =
        obj?.data?.getCalendarWidget!;

      return {
        filterList,
        seoCtaUrl: circuitCalendarLink,
        tournamentFilter: CATEGORIES.includes(tournamentFilter.toLowerCase())
          ? tournamentFilter
          : null,
        tournaments:
          tournaments?.length &&
          tournaments.map((item) => {
            const { surface, ...rest } = item!;
            return {
              ...rest,
              surface: surface && surfaceMap[surface],
              trackingData: { intcmp: intcmpMap.calendar }
            };
          }),
      } as ITennisCalendar;
    
  } else {
    throw new WidgetError<ErrorName>({
      name: 'NO_VALID_DATA',
      message: 'Invalid transformer input, Error in CalendarQuery object',
      data: obj
    });
  }
};
